export default "__VITE_ASSET__3539108f__"